import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageSquare, X, Send, Minimize2 } from 'lucide-react';
import { MOCK_CHAT_MESSAGES } from '../../utils/mockData';
export function LiveChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState(MOCK_CHAT_MESSAGES);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages, isOpen]);
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!inputValue.trim()) return;
    const newMessage = {
      id: Date.now().toString(),
      text: inputValue,
      sender: 'user',
      timestamp: 'now'
    };
    setMessages([...messages, newMessage]);
    setInputValue('');
    setIsTyping(true);
    // Simulate bot response
    setTimeout(() => {
      setIsTyping(false);
      setMessages(prev => [...prev, {
        id: (Date.now() + 1).toString(),
        text: 'Thanks for your message. A support agent will be with you shortly.',
        sender: 'bot',
        timestamp: 'now'
      }]);
    }, 1500);
  };
  return <>
      <AnimatePresence data-id="element-1175">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed bottom-24 right-6 w-80 sm:w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden z-50 flex flex-col" style={{
        height: '500px'
      }} data-id="element-1176">
            {/* Header */}
            <div className="bg-blue-600 p-4 flex justify-between items-center text-white" data-id="element-1177">
              <div className="flex items-center" data-id="element-1178">
                <div className="h-2 w-2 bg-green-400 rounded-full mr-2 animate-pulse" data-id="element-1179"></div>
                <span className="font-medium" data-id="element-1180">Renta Support</span>
              </div>
              <div className="flex space-x-2" data-id="element-1181">
                <button onClick={() => setIsOpen(false)} className="hover:bg-blue-700 p-1 rounded" data-id="element-1182">
                  <Minimize2 className="h-4 w-4" data-id="element-1183" />
                </button>
              </div>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 bg-gray-50 space-y-4" data-id="element-1184">
              {messages.map(msg => <div key={msg.id} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-1185">
                  <div className={`max-w-[80%] p-3 rounded-2xl text-sm ${msg.sender === 'user' ? 'bg-blue-600 text-white rounded-br-none' : 'bg-white text-gray-800 border border-gray-200 rounded-bl-none shadow-sm'}`} data-id="element-1186">
                    {msg.text}
                  </div>
                </div>)}
              {isTyping && <div className="flex justify-start" data-id="element-1187">
                  <div className="bg-white border border-gray-200 p-3 rounded-2xl rounded-bl-none shadow-sm" data-id="element-1188">
                    <div className="flex space-x-1" data-id="element-1189">
                      <div className="h-2 w-2 bg-gray-400 rounded-full animate-bounce" style={{
                  animationDelay: '0ms'
                }} data-id="element-1190"></div>
                      <div className="h-2 w-2 bg-gray-400 rounded-full animate-bounce" style={{
                  animationDelay: '150ms'
                }} data-id="element-1191"></div>
                      <div className="h-2 w-2 bg-gray-400 rounded-full animate-bounce" style={{
                  animationDelay: '300ms'
                }} data-id="element-1192"></div>
                    </div>
                  </div>
                </div>}
              <div ref={messagesEndRef} data-id="element-1193" />
            </div>

            {/* Input */}
            <form onSubmit={handleSend} className="p-4 bg-white border-t border-gray-200" data-id="element-1194">
              <div className="flex space-x-2" data-id="element-1195">
                <input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} placeholder="Type a message..." className="flex-1 border border-gray-300 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" data-id="element-1196" />
                <button type="submit" disabled={!inputValue.trim()} className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-1197">
                  <Send className="h-4 w-4" data-id="element-1198" />
                </button>
              </div>
            </form>
          </motion.div>}
      </AnimatePresence>

      <motion.button onClick={() => setIsOpen(!isOpen)} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} className="fixed bottom-6 right-6 h-14 w-14 bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center z-50 hover:bg-blue-700 transition-colors" data-id="element-1199">
        {isOpen ? <X className="h-6 w-6" data-id="element-1200" /> : <MessageSquare className="h-6 w-6" data-id="element-1201" />}
      </motion.button>
    </>;
}